import SessionMapper from '@tgtg/core/model/SessionMapper';
import RestClient from 'src/network/axios';

import type { Session } from '@tgtg/core/session';

type TokenLoginApiData = {
  csrfToken: string;
  isAuthenticated: boolean;
  payload: Session;
};

interface TokenLoginResponse {
  data: { data: TokenLoginApiData };
}

const login = (token: string): Promise<Session | null> =>
  RestClient.post<{ token: string }, TokenLoginResponse>('/web/auth/v3/tokenLogin', {
    token,
  }).then(
    ({
      data: {
        data: { csrfToken, isAuthenticated, payload },
      },
    }) => {
      RestClient.defaults.headers.common['X-CSRF-Token'] = csrfToken;
      if (!isAuthenticated) return null;
      return SessionMapper.map(payload);
    },
  );

const TokenLoginResource = {
  login,
};

export default TokenLoginResource;
